<template>
  <div>
    <vs-tabs class="bg_filled_tab_holder" v-model="tabIndex">
      <vs-tab label="Coursework">
        <div
          class="table-responsive cstm_vuexy_table"
          style="height: 150px; overflow: auto"
          @scroll="detectsScrollLength()"
          ref="element"
        >
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Subject</th>
                <th>No.of Questions</th>
                <th>Deadline</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(assignment, index) in assignmentList" :key="index">
                <td>{{ assignment.assignment_builder.title }}</td>
                <td>
                  {{
                    assignment.assignment_builder.has_all_subject
                      ? "General"
                      : getSubjects(assignment.assignment_builder.subject)
                  }}
                </td>
                <td>{{ assignment.assignment_builder.no_of_questions }}</td>
                <td>{{ assignment.assignment_builder.deadline }}</td>
                <td>
                  <vs-dropdown
                    style="margin-left: 5px; cursor: pointer"
                    vs-custom-content
                    vs-trigger-click
                  >
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-more-vertical"
                    ></vs-button>

                    <vs-dropdown-menu style="min-width: 100px">
                      <vs-dropdown-item v-if="assignment.teacher_status==2"  @click="viewDetails(assignment.assignment_type_id, assignment.id,assignment.client_user.client_users_id)">Mark</vs-dropdown-item>
                      <vs-dropdown-item @click="reassignModal(assignment)" :disabled="resassignDisable">Reassign</vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </td>
              </tr>
              <tr v-if="assignmentList==0" class="text-center">
                <td colspan="5">No Courseworks found</td>
              </tr>
            </tbody>
          </table>
        </div>
      </vs-tab>
      <vs-tab label="Exam">
        <div
          class="table-responsive cstm_vuexy_table"
          style="height: 150px; overflow: auto"
          @scroll="detectsScrollLength()"
          ref="element"
        >
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Subject</th>
                <th>No.of Questions</th>
                <th>Deadline</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(assignment, index) in assignmentList" :key="index">
                <td>{{ assignment.assignment_builder.title }}</td>
                <td>
                  {{
                    assignment.assignment_builder.has_all_subject
                      ? "General"
                      : getSubjects(assignment.assignment_builder.subject)
                  }}
                </td>
                <td>{{ assignment.assignment_builder.no_of_questions }}</td>
                <td>{{ assignment.assignment_builder.deadline }}</td>
                <td>
                  <vs-dropdown
                    style="margin-left: 5px; cursor: pointer"
                    vs-custom-content
                    vs-trigger-click
                  >
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-more-vertical"
                    ></vs-button>

                    <vs-dropdown-menu style="min-width: 100px">
                      <vs-dropdown-item v-if="assignment.teacher_status==2"  @click="viewDetails(assignment.assignment_type_id, assignment.id,assignment.client_user.client_users_id)">Mark</vs-dropdown-item>
                      <vs-dropdown-item @click="reassignModal(assignment)" :disabled="resassignDisable">Reassign</vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </td>
              </tr>
              <tr v-if="assignmentList==0" class="text-center">
                <td colspan="5">No Exams found</td>
              </tr>
            </tbody>
          </table>
        </div>
      </vs-tab>
      <vs-tab label="Report">
        <div
          class="table-responsive cstm_vuexy_table"
          style="height: 150px; overflow: auto"
          @scroll="detectsScrollLength()"
          ref="element"
        >
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Subject</th>
                <th>No.of Questions</th>
                <th>Deadline</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(assignment, index) in assignmentList" :key="index">
                <td>{{ assignment.assignment_builder.title }}</td>
                <td>
                  {{
                    assignment.assignment_builder.has_all_subject
                      ? "General"
                      : getSubjects(assignment.assignment_builder.subject)
                  }}
                </td>
                <td>{{ assignment.assignment_builder.no_of_questions }}</td>
                <td>{{ assignment.assignment_builder.deadline }}</td>
                <td>
                  <vs-dropdown
                    style="margin-left: 5px; cursor: pointer"
                    vs-custom-content
                    vs-trigger-click
                  >
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-more-vertical"
                    ></vs-button>

                    <vs-dropdown-menu style="min-width: 100px">
                      <vs-dropdown-item v-if="assignment.teacher_status==1"  @click="viewDetailsReport(assignment.assignment_type_id, assignment.id,assignment.client_user.client_users_id)">Fill In</vs-dropdown-item>
                      <vs-dropdown-item @click="editReport(assignment.assignment_type_id, assignment.id,assignment.client_user.client_users_id)">Edit</vs-dropdown-item>
                    </vs-dropdown-menu>
                  </vs-dropdown>
                </td>
              </tr>
              <tr v-if="assignmentList==0" class="text-center">
                <td colspan="5">No Reports found</td>
              </tr>
            </tbody>
          </table>
        </div>
      </vs-tab>
    </vs-tabs>
    <div v-if="assignOpen">

<ReportAssignComponent
 v-if="assignment_data.assignment_type_id==3"
:assignOpenModal= "assignOpen"
  :assignType="assignType"
  :dataObj="assignment_data"
  @assignclose="assignClose"
/>
 <AssignComponent
 v-else
:assignOpenModal= "assignOpen"
  :assignType="assignType"
  :dataObj="assignment_data"
  @assignclose="assignClose"
/>

</div>
  </div>
</template>
<script>
import ReportAssignComponent from '@/views/pages/v1/coursework/Reports/Template/ReportAssignModal.vue'
import AssignComponent from '@/views/pages/v1/coursework/components/Template/AssignComponent.vue'
import { fetchReceivedAssignment } from '@/api/dashboard.js'
export default {
  data () {
    return {
      tabIndex: 0,
      assignment_type_id: 2,
      assignmentList: [],
      assignment_data:null,
      assignmentList_meta: {
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      assignType: 'assign',
      assignOpen: false
    }
  },
  mounted () {
    this.fetchAssignment()
  },
  components: {
    ReportAssignComponent,
    AssignComponent
  },
  watch: {
    tabIndex () {
      if (this.tabIndex === 0) this.assignment_type_id = 2
      else if (this.tabIndex === 1) this.assignment_type_id = 4
      else if (this.tabIndex === 2) this.assignment_type_id = 3

      
      this.assignmentList = []
      this.assignmentList_meta = {
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      }
      this.fetchAssignment()

    }
  },
  methods: {
    async editReport (assignment_type_id, id, client_users_id) {
      this.$router.push({
        name: 'report-details',
        params: {
          assignment_type_id,
          assignment_builder_user_id: id,
          client_user: client_users_id
        }
      })
    },
    reassignModal (data) {
      this.assignOpen = true
      this.assignType = 'reassign'
      this.assignment_data = data
    },
    viewDetails (assignment_type_id, id, client_users_id) {
      if (assignment_type_id === 4) {
        this.$router.push({
          name: 'exam-details',
          params: {
            assignment_type_id,
            assignment_builder_user_id: id,
            client_user: client_users_id
          }
        })
      } else {
        this.$router.push({
          name: 'coursework-details',
          params: {
            assignment_type_id,
            assignment_builder_user_id: id,
            client_user: client_users_id
          }
        })
      }

    },
    viewDetailsReport (assignment_type_id, id, client_users_id) {
      this.$router.push({
        name: 'report-details',
        params: {
          assignment_type_id,
          assignment_builder_user_id: id,
          client_user: client_users_id
        }
      })
    },
    resassignDisable () {
      const date1 =  new Date(this.params.data.assignment_builder.deadline)
      const date2 = new Date()
      const Difference_In_Time = date2.getTime() - date1.getTime()
      const Difference_In_Days = Math.floor(Difference_In_Time / (1000 * 3600 * 24))
      if ((Difference_In_Days > 0) && (this.params.data.assignment_builder.has_submit_after_deadline === 1 || this.params.data.assignment_builder.has_submit_after_deadline)) {
        return false
      } else {
        if (Difference_In_Time > 0) return false
        return true
      }
    },
    getSubjects (subjects) {
      const subjectsArray = []
      subjects.forEach((e) => {
        subjectsArray.push(e.subject_name)
      })
      return subjectsArray.join(', ')
    },
    async fetchAssignment () {
      try {
        this.$vs.loading()
        const payload = {
          assignment_type_id: this.assignment_type_id,
          teacher_status:2,
          view_own:true
        }
        const { data } = await fetchReceivedAssignment(
          localStorage.getItem('customer_id'),
          payload,
          this.assignmentList_meta
        )
        this.assignmentList = data.data.courseWork
        this.assignmentList_meta = data.data.meta
        this.$vs.loading.close()
      } catch (e) {
        this.$vs.loading.close()
      }
      
    },
    detectsScrollLength () {
      if (
        Math.ceil(
          this.$refs.element.scrollTop + this.$refs.element.offsetHeight
        ) >= this.$refs.element.scrollHeight && this.assignmentList_meta.has_next
      ) {
        this.loadMoreAssignments()
      }
    },
    async loadMoreAssignments () {
      try {
        this.$vs.loading()
        this.assignmentList_meta.current_page += 1
        const payload = {
          assignment_type_id: this.assignment_type_id,
          teacher_status:2,
          view_own:true
        }
        const { data } = await fetchReceivedAssignment(
          localStorage.getItem('customer_id'),
          payload,
          this.assignmentList_meta
        )
        this.assignmentList.push(...data.data.courseWork)
        this.assignmentList_meta = data.data.meta
        this.$vs.loading.close()
      } catch (e) {
        this.$vs.loading.close()
      }
      
    }
  }
}
</script>